import {
  SIGNING_RETURN_MESSAGE_TYPE,
  type SigningReturnMessage,
  type SigningReturnOutcome,
} from '@/lib/contracts/signing-return-message';

export type SigningReturnRelay = 'framed' | 'unreachable';

/**
 * FR-4 / handover §5 — tell the framing host "the user left the provider UI". The message carries only
 * the outcome kind, never a signed claim; the host re-reads `signers[]` from the server.
 *
 * D-20 (PRD Rev 7): there is no tab relay. The fallback tab is opened without an opener, so a tab's
 * return page just says it can be closed and the host refreshes by polling.
 *
 * Runs once, before the page renders, so StrictMode's doubled effects can never post twice. The
 * target origin is always our own: a page framing this route from another origin receives nothing.
 */
export function relaySigningReturn(
  outcome: SigningReturnOutcome,
  win: Window = window,
): SigningReturnRelay {
  const message: SigningReturnMessage = { type: SIGNING_RETURN_MESSAGE_TYPE, outcome };
  try {
    if (win.parent && win.parent !== win) {
      win.parent.postMessage(message, win.location.origin);
      return 'framed';
    }
  } catch {
    // AC-4.6 — parent access threw. Fall through to the static close message.
  }
  return 'unreachable';
}
